import { NgModule } from "@angular/core";
import { NgxsModule } from "@ngxs/store";

import { AlertsDataState } from "./alerts";
import { UserContextState } from "./user-context";

@NgModule({
    imports: [
        NgxsModule.forFeature([AlertsDataState, UserContextState])
    ],
})
export class CoreModule { }